/**************************************************
 * Nombre:       Formulario_Fila.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    FlagOutlined,
    GroupOutlined,
    Mail,
    SmartphoneOutlined,
    WhatsApp
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {iniciarChatWass} from "../../Modulo_ChatWass/Funciones/iniciarChatWass";
import {PAISESINDICATIVO} from "../../Modulo_ChatWass/Utilidades/indicativos";
import {ESTADOSFILA} from "../../Constantes";

const Formulario_Fila = ({...props}) => {


    const chatWhatsApp = (num) => {

        iniciarChatWass({numero: props.props.getValues("celular"), pais: props.props.getValues("pais"), local: false});

    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSFILA.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Notificaciones'} {...props}
                                                 dato={'notificaciones'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTextoBoton Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                       click={chatWhatsApp} IconoFinal={WhatsApp}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto nombre={'Tiempo a quedarse (Horas)'} dato={'numHoras'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={GroupOutlined} nombre={'Numero Personas'} dato={'numPersonas'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Fila